import AppTable from '@launchpad/components/crud/AppTable';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppBadge from '@launchpad/components/typography/AppBadge';
import { UploadNewFileModal } from './UploadNewFileModal';
import AuthorisationImportFileModel from '../models/AuthorisationImportFileModel';

type UploadNewFileModalProps = {};

export const AuthorisationImportFileTable = (
  props: UploadNewFileModalProps
) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  return (
    <>
      <AppTable
        parseUrl={false}
        icon="list"
        title="Import files"
        filter={[
          {
            name: 'term',
            type: 'term',
          },
        ]}
        order={[
          {
            field: 'id',
            direction: 'desc',
          },
        ]}
        model={AuthorisationImportFileModel}
        headerActions={
          <button
            type="button"
            className="button width-240"
            style={{ marginRight: '10px' }}
            onClick={() => setModalVisible(true)}
          >
            <i className="fa fa-fw fa-plus" />
            Add new
          </button>
        }
        renderCell={(column, item, index) => {
          switch (column.name) {
            case 'status':
              return <AppBadge text={item.status} />;
            default:
              return item[column.name];
          }
        }}
        getColumnActions={(file, index) => {
          return (
            <div>
              <Link
                to={`/authorisation-import/files/${file.id}`}
                className="button-info"
              >
                Details
              </Link>
            </div>
          );
        }}
      />
      <UploadNewFileModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        modalText="Please upload a file!"
      />
    </>
  );
};

export default AuthorisationImportFileTable;
